import { defineMessages } from 'react-intl';

export const messages: {
	contextBannerLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referencingDocumentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeContextButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referencingDatabaseViewLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referencingSelectedCellsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referencingSelectedFieldsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referencingSelectedEntriesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referencingSelectedCardsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referencingIssuesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	contextBannerLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.label',
		defaultMessage: 'Context',
		description: 'Label for the context banner when not referencing selected text',
	},
	referencingDocumentLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.referencing-document-label',
		defaultMessage: 'Referencing selected text in',
		description: 'Label for the context banner when referencing selected text from a document',
	},
	removeContextButtonLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.remove-context-button-label',
		defaultMessage: 'Remove context',
		description: 'Accessible label for the button to remove/dismiss the context',
	},
	referencingDatabaseViewLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.referencing-database-view-label',
		defaultMessage: 'Referencing selected view in',
		description: 'Label for the context banner when referencing selected text from a database view',
	},
	referencingSelectedCellsLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.referencing-selected-cells-label',
		defaultMessage: 'Referencing selected {count, plural, one {cell} other {cells}} in',
		description:
			'Label for the context banner when referencing selected database cells; pluralizes cell/cells based on count',
	},
	referencingSelectedFieldsLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.referencing-selected-fields-label',
		defaultMessage: 'Referencing selected {count, plural, one {field} other {fields}} in',
		description:
			'Label for the context banner when referencing selected database fields; pluralizes field/fields based on count',
	},
	referencingSelectedEntriesLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.referencing-selected-entries-in-label',
		defaultMessage: 'Referencing selected {count, plural, one {entry} other {entries}} in',
		description:
			'Label for the context banner when referencing selected database entries; pluralizes entry/entries based on count',
	},
	referencingSelectedCardsLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.referencing-selected-cards-label',
		defaultMessage: 'Referencing selected {count, plural, one {card} other {cards}} in',
		description:
			'Label for the context banner when referencing selected cards; pluralizes card/cards based on count',
	},
	referencingIssuesLabel: {
		id: 'conversation-assistant-chat-prompt-input.context-banner.referencing-issues-label',
		defaultMessage: 'Referencing selected work in',
		description: 'Label for the context banner when referencing selected Jira work',
	},
});
